import { defineModule } from '@kubdee/sdk'
import { MODULES } from '@kubdee/shared'
import { migrations } from './migrations'
import { purchaseDoctypes } from './doctypes'

// 🔄 To change icon, also add the new icon to apps/web/src/lib/icon-registry.ts
const MODULE_ICON = 'ShoppingCart'  // Will differentiate with color
const MODULE_COLOR = '#2490EF'

export default defineModule({
  name: MODULES.PURCHASE,
  label: 'การซื้อ',
  icon: MODULE_ICON,
  color: MODULE_COLOR,
  version: '1.0.0',
  dependencies: [MODULES.CORE, MODULES.ACCOUNTING],
  category: 'finance',
  isSystemModule: false,

  schemas: {},
  routes: {},
  navigation: {
    label: 'การซื้อ',
    icon: MODULE_ICON,
    groups: [
      {
        label: 'ภาพรวม',
        items: [
          { label: 'แดชบอร์ด', path: '/purchase/dashboard', icon: 'LayoutDashboard' },
        ],
      },
      {
        label: 'ข้อมูลหลัก',
        items: [
          { label: 'ผู้จำหน่าย', path: '/purchase/suppliers', icon: 'Users' },
          { label: 'สินค้า/บริการ', path: '/purchase/items', icon: 'Package' },
        ],
      },
      {
        label: 'ธุรกรรมซื้อ',
        items: [
          { label: 'ใบสั่งซื้อ', path: '/purchase/purchase-orders', icon: 'FileText' },
          { label: 'ต้นทุนแฝง', path: '/purchase/landed-costs', icon: 'Ship' },
        ],
      },
      {
        label: 'รายงาน',
        items: [
          { label: 'รายงานการซื้อ', path: '/purchase/reports', icon: 'BarChart3' },
          { label: 'รายงานเทียบ PO-GR-PI', path: '/purchase/reports/procurement-variance', icon: 'ListChecks' },
        ],
      },
    ],
  },
  permissions: {},
  hooks: {},

  doctypes: [
    { key: "suppliers", label: "ผู้จำหน่าย" },
    { key: "purchase-orders", label: "ใบสั่งซื้อ", type: "submittable", branchScope: { type: "single", fields: ["branchId"], createField: "branchId" } },
    { key: "purchase-order-items", label: "รายการใบสั่งซื้อ" },
    { key: "landed-costs", label: "ต้นทุนแฝง", type: "submittable", branchScope: { type: "single", fields: ["branchId"], createField: "branchId" } },
    { key: "reports", label: "รายงาน" },
  ],
  availableHooks: [
    { event: "purchase.purchaseOrder.submitted", label: "ยืนยันใบสั่งซื้อ" },
  ],
  fixtures: [],

  moduleMigrations: migrations,

  // Doctype Admin Epic (#347), issue #413. See `./doctypes.ts` — the
  // platform boot loop in `apps/tenant-worker/src/middleware/auto-migrate.ts`
  // reads this field from every enabled module's manifest and upserts the
  // platform-default rows into `core_doctype_registry`.
  registeredDoctypes: purchaseDoctypes,
})
